<template>
  <div class="data-import-status-modal">
    <HMModalHeader
      :title="$t('DATA_IMPORT.TITLE.ERROR_DETAILS')"
      @close="$emit('close')"
    ></HMModalHeader>
    <pre class="status-message px-1 py-3 w-100">{{ status }}</pre>
  </div>
</template>

<script>
export default {
  name: 'DataImportErrorStatusModal',
  props: {
    status: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
.status-message {
}
</style>
